// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"973a8c72","453":"c90fdc69"}[chunkId] + ".chunk.js";
};